import { useConversationsContext } from "@/app/[tenantId]/[messengerId]/[hostConfig]/[locale]/lib/client/contexts/ConversationsContext";
import Badge from "../ui/Badge/Badge";
import useIsMessageHistoryEnabled from "@/app/[tenantId]/[messengerId]/[hostConfig]/[locale]/lib/client/hooks/useIsMessageHistoryEnabled";
import useCurrentConversationId from "@/app/[tenantId]/[messengerId]/[hostConfig]/[locale]/lib/client/hooks/useCurrentConversationId";
import { useCallback } from "react";

export default function UnreadBadge() {
  const isMessageHistoryEnabled = useIsMessageHistoryEnabled();
  const currentConversationId = useCurrentConversationId();
  const count = useConversationsContext(
    useCallback(
      (c) =>
        isMessageHistoryEnabled
          ? c.getUnreadCountExcept()
          : c.getUnreadCount(...(currentConversationId ? [currentConversationId] : [])),
      [currentConversationId, isMessageHistoryEnabled],
    ),
  );

  return count ? <Badge count={count} /> : null;
}
